import React from "react";
import { useAppSelector } from "../../../../../hooks/redux";
import { getLanguage } from "../../../../../store/selectors/appSelector";
import { IModule } from "../../../../../models/IModule";
import styles from "./BasicModulesItem.module.css";
import ModuleItemWrapper from "../../../Components/ModuleItemWrapper/ModuleItemWrapper";
// import ModuleImage from "../../../Components/ModuleImage/ModuleImage";
import { getTextByLanguage } from "../../../../../enums/utils/getTextByLanguage";

const BasicModulesItem = ({ title, description, images }: IModule) => {
	const language = useAppSelector(getLanguage);

	const descriptionText = getTextByLanguage(description, language, true);

	return (
		<ModuleItemWrapper>
			<div className={styles.titleWrapper}>
				<h3>{getTextByLanguage(title, language)}</h3>
			</div>

			{/* <ModuleImage images={images} title={getTextByLanguage(title, language)}/> */}

			{descriptionText ? <div className={styles.descriptionWrapper} dangerouslySetInnerHTML={{ __html: descriptionText }} /> : <></>}
		</ModuleItemWrapper>
	);
};

export default BasicModulesItem;
